export const actualPage: any = 1;
export const rowsPerPage: any = 15;
export const rowsPerPageOptions: any = [5, 10, 20, 50];
